import React from "react";

function Color_Theory() {
  return (
    <div>
      <h1>Color_Theory Component</h1>
      <p>This is the Color Theory tutorial page content.</p>
    </div>
  );
}

export default Color_Theory;
